module.exports = __webpack_public_path__ + "assets/atlassian bitbucket.9c517cee.svg";